<template>
  <div class="media-types">
    <div class="search-menu-label">
      MEDIA TYPES
    </div>
  <div class="media-types-holder">
    <div class="media-type" @click="handleMediaClick(0)" :class="(mediaTypes[0].isChecked) ? 'checked' : 'unchecked'">
      <div class="media-type-icon">
        <img :src="require('@/assets/svg/SVG/media_image.svg')">
      </div>
    </div>
    <div class="media-spacer"></div>
    <div class="media-type" @click="handleMediaClick(1)" :class="(mediaTypes[1].isChecked) ? 'checked' : 'unchecked'">
      <div class="media-type-icon">
        <img :src="require('@/assets/svg/SVG/media_video.svg')">
      </div>
    </div>
    <div class="media-spacer"></div>
    <div class="media-type" @click="handleMediaClick(2)" :class="(mediaTypes[2].isChecked) ? 'checked' : 'unchecked'">
      <div class="media-type-icon">
        <img :src="require('@/assets/svg/SVG/media_document.svg')">
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import {storeToRefs} from 'pinia/dist/pinia';
import {useRMTStore} from '@/store/RMTStore';

export default {
  name: 'MediaTypes',
  setup () {
    const RMTStore = useRMTStore();
    const { mediaTypes } = storeToRefs(RMTStore);
    return {
      RMTStore,
      mediaTypes
    };
  },
  methods: {
    handleMediaClick (e) {
      this.RMTStore.mediaTypes[e].isChecked = !this.RMTStore.mediaTypes[e].isChecked;

      if (this.RMTStore.getSearchType === 0) {
        this.RMTStore.filterResources('reset page');
        // this.RMTStore.filterResources({target: {value: this.RMTStore.mediaTypes[e].name}});
      } else {
        this.RMTStore.filterCollections({target: {value: this.RMTStore.mediaTypes[e].name}});
      }
    }
  }
};
</script>

<style scoped>

.media-types-holder {
  display: flex;
  flex-direction: row;
}

.media-type {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 25px;
  background-color: #e8e8e8;
  width: 46px;
  height: 30px;
  cursor: pointer;
  transition: .1s opacity;
}

.media-type-icon {
  width: 25px;
  height: 25px;
}

.media-spacer {
  width: 5px;
}

.checked {
  background-color: #d3d3d3;
}

.unchecked {
  opacity: .5;
}

</style>